import { jsx } from "react/jsx-runtime";
import { cn } from "@pcln/horizon";
function SearchFormGrid({ children, gridClassName, ariaLabel, onSubmit, containerRef, containerClassName, formClassName, innerClassName }) {
    return /*#__PURE__*/ jsx("div", {
        ref: containerRef,
        className: cn('@container isolate w-auto', containerClassName),
        children: /*#__PURE__*/ jsx("form", {
            className: cn('w-auto', formClassName),
            "aria-label": ariaLabel,
            onSubmit: onSubmit,
            children: /*#__PURE__*/ jsx("div", {
                className: cn('mx-auto w-auto', innerClassName),
                children: /*#__PURE__*/ jsx("div", {
                    className: gridClassName,
                    children: children
                })
            })
        })
    });
}
export { SearchFormGrid };
